import { Component } from '@angular/core';
import { PartiallyDeliveredReasonsEditComponent } from '../../../../components/admin-dashboard-component/partially-delivered-reasons-component/partially-delivered-reasons-edit-component/partially-delivered-reasons-edit-component';

@Component({
  selector: 'app-partially-delivered-reasons-edit',
  imports: [PartiallyDeliveredReasonsEditComponent],
  templateUrl: './partially-delivered-reasons-edit.html',
  styleUrl: './partially-delivered-reasons-edit.scss'
})
export class PartiallyDeliveredReasonsEdit {

}
